export default __webpack_public_path__ + "onboardingEmergencyVehicles.4134a55e.png";